export default __webpack_public_path__ + "static/media/51.beea1158.jpeg";